export const cases = [
  {
    id: 'transparencia',
    name: 'Transparência Internacional Brasil',
    year: '2024',
    service: {
      pt: 'Plataforma · Inteligência de dados',
      en: 'Platform · Data intelligence',
    },
    description: {
      pt: 'Plataforma de inteligência de dados para monitorar a transparência pública no Brasil.',
      en: 'A data intelligence platform for monitoring public transparency in Brazil.',
    },
  },
  {
    id: 'seict',
    name: 'SEICT Acre · IMA Amazônia',
    year: '2025',
    service: {
      pt: 'Gestão pública · Gamificação',
      en: 'Public sector · Gamification',
    },
    description: {
      pt: 'Soluções digitais para gestão governamental, com recursos de gamificação voltados ao engajamento do público e das equipes envolvidas.',
      en: 'Digital solutions for government management, featuring gamification tools designed to engage users and participating teams.',
    },
  },
  {
    id: 'talanoa',
    name: 'Instituto Talanoa',
    year: '2021',
    service: {
      pt: 'Inteligência de dados climáticos',
      en: 'Climate data intelligence',
    },
    description: {
      pt: 'Sistemas de inteligência de dados aplicados ao monitoramento e à análise da política climática brasileira.',
      en: 'Data intelligence systems for monitoring and analyzing Brazilian climate policy.',
    },
  },
  {
    id: 'chicomendes-consultoria',
    name: 'Comitê Chico Mendes',
    year: '2025',
    service: {
      pt: 'Produto digital · Consultoria',
      en: 'Digital product · Consulting',
    },
    description: {
      pt: 'Desenvolvimento de soluções digitais e consultoria tecnológica para fortalecer a atuação de defensores da floresta.',
      en: 'Digital product development and technology consulting to strengthen the work of forest defenders.',
    },
  },
  {
    id: 'chicomendes-intranet',
    name: 'Comitê Chico Mendes',
    year: '2026',
    service: {
      pt: 'Produto digital · Desenvolvimento',
      en: 'Digital product · Development',
    },
    description: {
      pt: 'Desenvolvimento de uma intranet mobile first para comunicação, organização e gestão interna da instituição.',
      en: 'Development of a mobile-first intranet for the organization’s internal communication, coordination, and management.',
    },
  },
  {
    id: 'maredepls',
    name: 'Maré de PLs',
    year: '2026',
    service: {
      pt: 'Produto digital · Desenvolvimento',
      en: 'Digital product · Development',
    },
    description: {
      pt: 'Desenvolvimento de uma plataforma mobile first para mobilização e envio de e-mails em escala a tomadores de decisão.',
      en: 'Development of a mobile-first platform for public mobilization and large-scale email outreach to decision-makers.',
    },
  },
  {
    id: 'alertacidade',
    name: 'O Alerta Cidade',
    year: '2024',
    service: {
      pt: 'Portal de notícias independente',
      en: 'Independent news portal',
    },
    description: {
      pt: 'Portal de notícias hiperlocal desenvolvido para fortalecer o jornalismo independente na região Norte do Brasil.',
      en: 'A hyperlocal news portal developed to strengthen independent journalism in Northern Brazil.',
    },
  },
  {
    id: 'editorjuridico',
    name: 'Editor Jurídico Lawork',
    year: '2024',
    service: {
      pt: 'Produto próprio · IA',
      en: 'In-house product · AI',
    },
    description: {
      pt: 'Plataforma própria para criação, edição, revisão e formatação de documentos jurídicos com apoio de inteligência artificial.',
      en: 'An in-house platform for creating, editing, reviewing, and formatting legal documents with AI support.',
    },
  },
];